import React from 'react'
import PromotionInclusionItem from 'components/Cruises/PromotionInclusions/PromotionInclusionItem'

interface Props {
  evergreenInclusions: Array<App.EvergreenInclusion>
  cabinType?: string
  cabinCategory?: string
}

function EvergreenInclusionList({ evergreenInclusions, cabinCategory, cabinType } : Props) {
  const evergreenInclusionLabels = (evergreenInclusions ?? [])
    .filter((inclusion) => {
      const categoryMatch = !cabinCategory || inclusion.cabinCategories.includes(cabinCategory)
      const typeMatch = !cabinType || inclusion.cabinTypes.includes(cabinType)

      return categoryMatch && typeMatch
    })
    .map((inclusion) => inclusion.inclusion)

  return <>
    {!!evergreenInclusionLabels.length && evergreenInclusionLabels.map((inclusion) => {
      return <PromotionInclusionItem
        key={inclusion}
        inclusion={inclusion}
        highlight
        type="access"
      />
    })}
  </>
}

export default EvergreenInclusionList
